import React from "react";
import "./WebTocListItem.css";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";

class WebTocListItem extends React.Component {
  constructor(props) {
    super(props);

    this.createClicked = this.createClicked.bind(this);

    this.onTitleChange = this.onTitleChange.bind(this);
    this.deleteClicked = this.deleteClicked.bind(this);
  }

  createClicked() {
    const { idx, createClicked } = this.props;

    createClicked(idx);
  }

  deleteClicked() {
    const { isSaveLoading, article, deleteWebTocArticle } = this.props;

    if (isSaveLoading) {
      return;
    }

    deleteWebTocArticle(article.id);
  }

  onTitleChange(event) {
    const { isSaveLoading, article, modifyOneWebTocData } = this.props;

    if (isSaveLoading) {
      return;
    }

    modifyOneWebTocData(article.id, event.target.value);
  }

  render() {
    const { idx, article, isSaveLoading } = this.props;

    return (
      <Card text="dark" className="toc_list_card">
        <Card.Header style={{ paddingTop: "5px", paddingBottom: "5px" }}>
          <span className="toc_order_number">{idx}</span>
          <Button
            disabled={isSaveLoading}
            variant="danger"
            size="sm"
            className="toc_delete_btn"
            onClick={this.deleteClicked}
          >
            <span className="fa fa-trash" />
          </Button>
          <Button
            disabled={isSaveLoading}
            variant="warning"
            size="sm"
            className="toc_delete_btn"
            onClick={this.createClicked}
          >
            <span className="fa fa-plus" />
          </Button>
        </Card.Header>
        <Card.Body style={{ paddingTop: "0", paddingBottom: "0" }}>
          <Row>
            <Col
              xs="12"
              sm="12"
              md="12"
              lg="12"
              xl="12"
              style={{ padding: "5px" }}
            >
              <Form.Control
                as="textarea"
                size="sm"
                type="text"
                style={{ height: 70 }}
                value={article.title}
                onChange={this.onTitleChange}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  }
}

export default WebTocListItem;
